import { ID } from '../../utils/codecUtils';
import { z } from 'zod';

export const deleteEndpoint = (ruleId: ID) => {
  return {
    endpoint: `/rules/${ruleId}`,
    method: 'DELETE',
    responseSchema: z.unknown(),
  } as const;
};
